
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.333 17.5c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 01-.49-1.177V12.5H7.5v1.667h5V12.5h5.833v3.333c0 .459-.163.851-.49 1.178-.326.326-.718.49-1.176.49H3.333zm5.834-5v-1.667h1.666V12.5H9.167zm-7.5-1.667V6.667c0-.459.163-.851.49-1.177.326-.327.718-.49 1.176-.49h3.334V3.333c0-.458.163-.85.49-1.177.326-.326.718-.49 1.176-.49h3.334c.458 0 .85.164 1.177.49.326.327.49.72.49 1.177V5h3.333c.458 0 .85.163 1.177.49.326.326.49.718.49 1.177v4.166H12.5V9.167h-5v1.666H1.667zM8.333 5h3.334V3.333H8.333V5z"}})])
          )
        }
      }
    